import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Indicator } from 'client/voladeum/indicators/types';
import { SLICE } from 'ducks/slice';

import { EMPTY_ARRAY } from '../../constants';

const initialState: Indicator[] = EMPTY_ARRAY;

export const indicatorsSlice = createSlice({
  name: SLICE.INDICATORS,
  initialState,
  reducers: {
    setIndicators: (_state, action: PayloadAction<Indicator[]>) => {
      return action.payload;
    },
    clearIndicators: () => {
      return initialState;
    },
  },
});

export const { setIndicators, clearIndicators } = indicatorsSlice.actions;

export default indicatorsSlice.reducer;
